const validateInput = (error:string, value:string, callback:Function):void => {
  if (value) {
    callback();
  } else {
    
    callback(new Error(error));
  }
};
const validateClass = (rule:any, callback:Function,form:any) => {
  if (form.big_class || form.small_class ) {
    callback();
  } else {
    
    callback(new Error('请选择配件分类'));
  }
};
export {
  validateInput,
  validateClass
}